
 // helpers/uswd.js

import axios from "axios";

/* ======================================================
   GET USWD RATE OPTIONS
   - Fixed: 1 USWD = 1 USDT
   - Configured: rate and minimum from backend
====================================================== */

export const fetchUSWDRate = async () => {
  try {
    const res = await axios.get("/api/uswd/rate", {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   GET SELLER STATUS
====================================================== */

export const fetchSellerStatus = async () => {
  try {
    const res = await axios.get("/api/uswd/seller-status", {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   GET USWD PRICING
====================================================== */

export const fetchUSWDPricing = async ({
  amount,
  paymentMethod = "usdt",
  currency = "USD",
}) => {
  try {
    const res = await axios.get("/api/uswd/pricing", {
      params: {
        amount,
        paymentMethod,
        currency,
      },
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   GET USWD TRANSACTION CONFIG
====================================================== */

export const fetchUSWDTransactionConfig = async ({
  recipientAddress,
  amount,
}) => {
  try {
    const res = await axios.post(
      "/api/uswd/transaction-config",
      {
        recipientAddress,
        amount,
      },
      {
        withCredentials: true,
      }
    );

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   BUY USWD
   pricingOption:
   - "fixed"
   - "configured"
====================================================== */

export const buyUSWD = async ({
  amount,
  pricingOption = "fixed",
  paymentMethod = "usdt",
  currency = "USD",
}) => {
  try {
    const res = await axios.post(
      "/api/uswd/buy",
      {
        amount,
        pricingOption,
        paymentMethod,
        currency,
      },
      {
        withCredentials: true,
      }
    );

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   SELL USWD
====================================================== */

export const sellUSWD = async ({
  amount,
  paymentMethod = "usdt",
  currency = "USD",
  timestamp,
  signature,
}) => {
  try {
    const res = await axios.post(
      "/api/uswd/sell",
      {
        amount,
        paymentMethod,
        currency,
        timestamp,
        signature,
      },
      {
        withCredentials: true,
      }
    );

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};

/* ======================================================
   GET USWD HISTORY
====================================================== */

export const fetchUSWDHistory = async () => {
  try {
    const res = await axios.get("/api/uswd/history", {
      withCredentials: true,
    });

    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};
